var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-row middle box start list"},[_c('div',{staticStyle:{"font-size":"20px","font-weight":"600"}},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }